import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';

import { buscarProveedores } from '../../actions/proveedores';
import { editarBreadcrumb } from '../../actions/breadcrumb';

import EliminarProveedor from './EliminarProveedor';
import FiltrosProveedor from './FiltrosProveedor';

const filtrosVacios = { nombre: '', contacto: '' };

const Proveedores = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { listado } = useSelector(state => state.proveedores);
    const { usuario } = useSelector(state => state.auth);

    const [proveedorEliminar, setProveedorEliminar] = useState(null);
    const [filtrosModal, setFiltrosModal] = useState(false);
    const [filtros, setFiltros] = useState(filtrosVacios);

    useEffect(() => {
        dispatch(buscarProveedores(filtrosVacios));
        dispatch(editarBreadcrumb([
            { nombre: 'Proveedores', path: '/proveedores', activo: true }
        ]));
    }, []);

    const handleAplicarFiltros = (nuevosFiltros) => {
        setFiltros(nuevosFiltros);
        dispatch(buscarProveedores(nuevosFiltros));
    };

    const handleCerrarEliminar = () => {
        setProveedorEliminar(null);
    };

    const filtrosActivos = [filtros.nombre, filtros.contacto].filter(Boolean).length;

    const columns = [
        {
            name: 'Nombre',
            sortable: true,
            selector: row => row.nombre || '-',
            grow: 2
        },
        {
            name: 'Correo',
            sortable: true,
            selector: row => row.correo || '-',
            grow: 1.5
        },
        {
            name: 'Dirección',
            sortable: true,
            selector: row => row.direccion || '-',
            grow: 3
        },
        {
            name: 'Teléfono',
            sortable: true,
            selector: row => row.telefono || '-'
        },
        {
            name: 'Contacto',
            sortable: true,
            selector: row => row.contacto || '-',
            grow: 1.5
        },
        {
            name: '',
            cell: row => (
                <div>
                    {usuario?.permisos?.proveedores?.ver && (
                        <Link className="btn btn-sm btn-info me-1" title="Ver perfil" to={`/proveedores/perfil/${row._id}`}>
                            <i className="fas fa-eye"></i>
                        </Link>
                    )}
                    {usuario?.permisos?.proveedores?.editar && (
                        <button
                            className="btn btn-sm btn-warning me-1"
                            title="Editar"
                            onClick={() => navigate(`/proveedores/editar/${row._id}`)}
                        >
                            <i className="fas fa-edit"></i>
                        </button>
                    )}
                    {usuario?.permisos?.proveedores?.eliminar && (
                        <button
                            className="btn btn-sm btn-danger"
                            title="Eliminar"
                            onClick={() => setProveedorEliminar(row)}
                        >
                            <i className="fas fa-trash"></i>
                        </button>
                    )}
                </div>
            )
        }
    ];

    return (
        <div className="row mt-5">
            <div className="col-12 mb-3 d-flex justify-content-between align-items-center">
                <h4 className="mb-4">Proveedores</h4>
                <div className="d-flex gap-3">
                    <button className="btn btn-secondary position-relative" onClick={() => setFiltrosModal(true)}>
                        <i className="fas fa-filter me-1"></i> Filtros
                        {filtrosActivos > 0 && (
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
                                {filtrosActivos}
                            </span>
                        )}
                    </button>
                    {usuario?.permisos?.proveedores?.agregar && (
                        <button className="btn btn-primary" onClick={() => navigate('/proveedores/nuevo')}>
                            <i className="fas fa-plus me-1"></i> Nuevo proveedor
                        </button>
                    )}
                </div>
            </div>

            <div className="col-12">
                <DataTable
                    columns={columns}
                    data={listado}
                    pagination
                    paginationPerPage={20}
                    paginationComponentOptions={{ rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' }}
                    highlightOnHover
                    noDataComponent="No hay proveedores registrados"
                />
            </div>

            <FiltrosProveedor
                show={filtrosModal}
                handleCerrar={() => setFiltrosModal(false)}
                filtros={filtros}
                handleAplicar={handleAplicarFiltros}
            />

            <EliminarProveedor
                proveedor={proveedorEliminar}
                handleCerrar={handleCerrarEliminar}
            />
        </div>
    );
};

export default Proveedores;
